import env from 'env';
import axios from 'axios';
import Qs from 'qs';

const monarch = axios.create({
  baseURL: env.monarchBaseUrl,
  responseType: 'json',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

let store;
export function setStore(s) {
  store = s;
  s.subscribe(listener);
}

function select(state) {
  return state.account.user && state.account.user.accessToken;
}

function listener() {
  let token = select(store.getState());

  monarch.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export default monarch;
